import {
  CancelSubscriptionStatus,
  Subscription,
} from '@models/membership/Subscription'
import {
  cancelSubscription,
  markSubscriptionToCancel,
} from '@services/membership/SubscriptionService'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  createSubscription,
  deleteSubscription,
  selectSelectedSubscription,
} from '@store/membership/SubscriptionReducer'
import { SBRM, SBRMForm, useSBRMForm } from '@supplement-bacon/sbrm-react'
import { formatPhoneNumberToE164FromPhoneInput } from '@utils/PhoneFormatter'
import { forwardRef } from 'react'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

type UpdateCommonValues = {
  id: Subscription['id']
}
type UpdateCancellationValues = {
  status: CancelSubscriptionStatus
}

export const MembershipSubscriptionForm: SBRMForm = forwardRef(
  ({ formProps }, ref) => {
    const { sections } = useSBRMForm()
    const dispatch = useAppDispatch()
    const { error } = useAppSelector((state) => state.subscription)
    const selectedSubscription = useAppSelector(selectSelectedSubscription())

    return (
      <SBRM.BaseEntityForm
        {...{ ref, formProps }}
        error={error && String(error)}
        formActions={{
          create: Create,
          update: Update,
          delete: Delete,
        }}
        handlers={{
          create: async (values) => {
            const personsWithCorrectPhoneNumber = values.persons.map(
              (person: any) => ({
                ...person,
                phone: formatPhoneNumberToE164FromPhoneInput(person.phone),
              })
            )

            return dispatch(
              createSubscription({
                ...values,
                persons: personsWithCorrectPhoneNumber,
              })
            ).then(() => {
              return true
            })
          },
          update: async (
            values: UpdateCommonValues & UpdateCancellationValues
          ) => {
            if (Array.isArray(sections) && sections.includes('cancellation')) {
              const nextStatus: CancelSubscriptionStatus = (
                values as UpdateCancellationValues
              ).status
              if (nextStatus === 'cancelled') {
                await cancelSubscription(values.id)
              } else if (nextStatus === 'to_cancel') {
                await markSubscriptionToCancel(values.id)
              }

              return true
            }
            if (!selectedSubscription) {
              return Promise.resolve(false)
            }
            return true
          },
          delete: async (values) =>
            dispatch(deleteSubscription(values)).then(() => {
              return true
            }),
        }}
      />
    )
  }
)

MembershipSubscriptionForm.displayName = 'MembershipSubscriptionForm'

export default MembershipSubscriptionForm
